import { Component, OnDestroy, OnInit, Renderer2, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { Subscription } from 'rxjs';
import { CompanyDocumentType, CompanyDocumentTypeToString } from '../../model/const/documentEnums';
import { SelectionItem } from '../../../core/component/select/select.component';
import { CompanyDocumentService } from '../../service/data/company-document.service';
import { Company } from '../../model/company';
import { CompanyDocument } from '../../model/company-document';

@Component({
    selector: 'app-company-document-form',
    templateUrl: './company-document-form.component.html',
    styleUrls: ['./company-document-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CompanyDocumentFormComponent implements OnDestroy, OnInit {
  constructor(
    private _actionService: ActionWindowService,
    private _dataService: CompanyDocumentService,
    private _fb: FormBuilder,
    private _fcf: FormControlExFactory
  ) {}

  private _subscription: Subscription = new Subscription();
  dataContext: Company;
  form: FormGroup;

  connectionTypes: SelectionItem[];

  cancel() {
    this._actionService.close();
  }

  ngOnDestroy() {
    this._subscription.unsubscribe();
    this._subscription = null;
  }

  ngOnInit() {
    this.connectionTypes = [
      CompanyDocumentType.General,
      CompanyDocumentType.PlanDrawing,
      CompanyDocumentType.FacadeDrawing,
      CompanyDocumentType.SituationPlan,
      CompanyDocumentType.Agreement,
      CompanyDocumentType.Photo,
    ].map(t => new SelectionItem(CompanyDocumentTypeToString(t), t));

    this.form = this._fb.group({
      caption: this._fcf.createMandatory('LEASE_AGREEMENT_DOCUMENT.CAPTION', ''),
      connectionType: this._fcf.createMandatory('DOCUMENT.DOCUMENT_TYPE', CompanyDocumentType.General),
      document: this._fcf.createMandatory('', null),
      company: this._fcf.createHidden(this.dataContext.id),
    });
  }

  onFileChange(files: FileList) {
    if (files && files.length === 1) {
      this.form.controls['document'].setValue(files[0]);
      this.form.controls['caption'].setValue(files[0].name.substr(0, files[0].name.lastIndexOf('.')));
    } else {
      this.form.controls['caption'].reset();
    }
  }

  onSubmit() {
    if (this.form.valid) {
      this._subscription.add(
        this._dataService.add(Object.assign(new CompanyDocument(), this.form.value)).subscribe(() => this._actionService.complete(true))
      );
    }
  }
}
